import { QueryFilterParameter } from './../../widgets/filters/models/query-filter-parameter.model';
import { Injectable } from '@angular/core';
import { BaseService, RequestOptions } from 'src/app/services/base.service';
import { CaptionArray, FcValGrphInptDataFilterData, FCValGrphOutputData, Updateclientresponse } from 'src/app/models/forecast/fc-validationlog-model';
import { Observable } from 'rxjs';
import { OverviewFilterInput, ValidFilters } from '../stock/stock.service';
import { FcPivotModel } from '../../models/forecast/fc-pivot-model';
import { ReturnFlag } from 'src/app/models/return-flag';
 
@Injectable({
  providedIn: 'root'
})
export class FcvalidationlogService {

  constructor(private baseService: BaseService) { }

  getForecastvaldata(Action: string = '', pageNo: number = 1, pageSize: number = 51, filterOutpout: QueryFilterParameter[]): Observable<FCValGrphOutputData> {
    let url = `forecast/GetFcValidationData?obj.Action=${Action}&obj.pageNo=${pageNo}&obj.pageSize=${pageSize}`;
    if (filterOutpout && filterOutpout.length > 0) {
      for (let i = 0; i < filterOutpout.length; i++) {
        const filtersOptions = filterOutpout[i];
        url += `&obj.filters[${i}].fieldName=${filtersOptions.fieldName}&obj.filters[${i}].value=${filtersOptions.value}&obj.filters[${i}].operation=${filtersOptions.operation}`;
      }
    }
    return this.baseService.get(url);
  }

  getForecastvaldataNew(Action: string = '', pageNo: number = 1, pageSize: number = 51, filterOutpout: QueryFilterParameter[]): Observable<FCValGrphOutputData> {
    let url = `forecast/GetFcValidationDataNew`;
    let obj: FcValGrphInptDataFilterData = new FcValGrphInptDataFilterData();
    obj.action = Action;
    obj.pageSize = pageSize;
    obj.pageNo = pageNo;
    obj.Filters = filterOutpout;
    return this.baseService.post(url, obj);
  }

  updateclientresponse(obj: any): Observable<Updateclientresponse> {
    let url = `forecast/updateclientresponse?forecastobjid=${obj.forecastobjid}&issue=${obj.issue}&comment=${encodeURIComponent(obj.comment)}`;
    return this.baseService.get(url); 
  }

  getValidationFilters(filtersData: QueryFilterParameter[]): Observable<OverviewFilterInput[]> {
    let url = 'forecast/GetValidationFilters';
    let filters: QueryFilterParameter[] = filtersData;
    return this.baseService.post(url,filters);
  }

  getFcPivotData() {
    let url = `forecast/GetForecastPivotdata`;
    return this.baseService.get(url);
  }

  GetForecastPivotColumnV2() {
    let url = `forecast/GetForecastPivotColumnV2`;
    return this.baseService.get(url);
  }

  getPivotUserSettings(userId: string) {
    let url = `forecast/GetPivotUserSettings?userId=${userId}`;
    return this.baseService.get(url);
  }

  savePivotUserSettings(pivotparam, userId: string) {
    console.log(pivotparam);
    let url = `forecast/SavePivotUserSettings?userId=${userId}`;
    return this.baseService.post<FcPivotModel>(url, pivotparam);
  }

  UpdateValidationFilters(obj: ValidFilters): Observable<ReturnFlag> {
    let url = `forecast/UpdateValidationFilters`;
    return this.baseService.post(url,obj); 
  }

  getCaptionbyAction(action: string, requestOptions?: RequestOptions): Observable<CaptionArray[]>{
    let url = `Settings/GetCaptionByAction?action=${action}`;
    return this.baseService.post(url,null,requestOptions); 
  }
}




